/**
 * Klaviyo Newsletter Form
 *
 * Submits our own custom-designed newsletter form (no native Shopify form,
 * no Klaviyo-controlled embed markup) directly to a specific Klaviyo list
 * via Klaviyo's public Client API subscriptions endpoint.
 *
 * Expects markup:
 *   <div class="klaviyo-newsletter" data-klaviyo-newsletter>
 *     <form data-klaviyo-newsletter-form data-list-id="..." data-company-id="..." data-source="...">
 *       <input type="email" required>
 *       <button type="submit">...</button>
 *     </form>
 *   </div>
 */
(function () {
  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_REVISION = '2024-10-15';
  var DEFAULT_COMPANY_ID = 'WPrCtm';

  function setState(root, state) {
    root.setAttribute('data-state', state);
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches('[data-klaviyo-newsletter-form]')) return;

    event.preventDefault();

    var root = form.closest('[data-klaviyo-newsletter]') || form.parentElement;
    var emailInput = form.querySelector('input[type="email"]');
    var submitButton = form.querySelector('button[type="submit"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var listId = form.getAttribute('data-list-id');
    var companyId = form.getAttribute('data-company-id') || DEFAULT_COMPANY_ID;
    var source = form.getAttribute('data-source') || 'Newsletter Form';

    if (!email || !listId) {
      setState(root, 'error');
      return;
    }

    if (submitButton) submitButton.disabled = true;

    fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        revision: KLAVIYO_REVISION,
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email },
              },
            },
          },
          relationships: {
            list: {
              data: { type: 'list', id: listId },
            },
          },
        },
      }),
    })
      .then(function (response) {
        if (response.ok) {
          setState(root, 'success');
          form.reset();
        } else {
          console.error('Klaviyo subscription failed:', response.status, response.statusText);
          setState(root, 'error');
        }
      })
      .catch(function (error) {
        console.error('Klaviyo subscription request error:', error);
        setState(root, 'error');
      })
      .finally(function () {
        if (submitButton) submitButton.disabled = false;
      });
  }

  document.addEventListener('submit', handleSubmit);
})();
